import {
  IconButton,
  TableBody,
} from "@material-ui/core";
import React from "react";

import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../../../../partials/datatable/styles";
import { ExpandIcon } from "../../../../../../../../components/IconsSVG";
import { InfoOutlined, OpenInNewTwoTone } from "@material-ui/icons";

export const TableBodyContent = ({
  logsList,
  setPublication,
  togglePublicationModal,
}) => {
  const court = (number) => {
    return `${number?.slice(0, 7)}-${number?.slice(7, 9)}.${number?.slice(
      9,
      13
    )}.${number?.slice(13, 14)}.${number?.slice(14, 16)}.${number?.slice(16)}`;
  };
  return (
    <TableBody
      style={{
        textAlign: "left",
      }}
    >
      {logsList.map((row) => (
        <StyledTableRow key={row.id}>
          <StyledTableCell
            style={{
              textAlign: "left",
            }}
          >
            {row?.lawsuitId ? (
              <a
                href={`/admin/processo/${row?.lawsuitId}/editar`}
                style={{ fontWeight: "700" }}
              >
                {row?.courtCaseNumber ? court(row?.courtCaseNumber) : "---"}
              </a>
            ) : (
              court(row?.courtCaseNumber)
            )}
          </StyledTableCell>
          <StyledTableCell
            style={{
              padding: "4px 10px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: row.isNotified ? "#0b8a0b" : "#b80808",
                marginRight: "5px",
                display: "inline-block",
                verticalAlign: "middle",
              }}
            />
            {row.isNotified ? "Sim" : "Não"}
          </StyledTableCell>
          <StyledTableCell
            style={{
              padding: "4px 10px",
              textAlign: "center",
            }}
            title={row.whatsappLastError || ""}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: row.whatsappNotified ? "#0b8a0b" : "#b80808",
                marginRight: "5px",
                display: "inline-block",
                verticalAlign: "middle",
              }}
            />
            {row.whatsappNotified ? "Sim" : "Não"}
          </StyledTableCell>
          <StyledTableCell
            style={{
              textAlign: "left",
            }}
          >
            {row?.dailyName}
          </StyledTableCell>
          <StyledTableCell
            style={{
              textAlign: "left",
            }}
          >
            {row?.dailyBook}
          </StyledTableCell>
          <StyledTableCell
            style={{
              textAlign: "left",
            }}
          >
            {row?.originalText}
          </StyledTableCell>
          <StyledTableCell
            style={{
              textAlign: "left",
            }}
          >
            {new Date(row.publicationDate)
              .toLocaleString("pt-BR")
              .replace(",", " - ")}
          </StyledTableCell>
          <StyledTableCell
            style={{
              padding: "4px 10px",
              textAlign: "center",
            }}
          >
            <IconButton
              size="small"
              title="Visualizar"
              style={{
                width: "30px",
                height: "30px",
                color: "#cacaca",
              }}
              onClick={() => {
                setPublication(row);
                togglePublicationModal();
              }}
            >
              <ExpandIcon />
            </IconButton>
          </StyledTableCell>
          <StyledTableCell
            style={{
              padding: "4px 10px",
              textAlign: "center",
            }}
          >
            {row?.lawsuitId ? (
              <a href={`/admin/processo/${row.lawsuitId}/editar`}>
                <IconButton
                  size="small"
                  title="Abrir"
                  style={{
                    width: "30px",
                    height: "30px",
                    color: "#cacaca",
                  }}
                >
                  <OpenInNewTwoTone />
                </IconButton>
              </a>
            ) : (
              <IconButton
                size="small"
                title="ESTA PUBLICAÇÃO AINDA NÃO FOI VINCULADA A NENHUM PROCESSO"
                style={{
                  width: "30px",
                  height: "30px",
                  color: "#cacaca",
                }}
              >
                <InfoOutlined />
              </IconButton>
            )}
          </StyledTableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  );
};
